var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"library-article"},[(!_vm.isCareer)?[_c('page-filter',{staticClass:"library-article-filter",attrs:{"data":[
        {
          name: '分类',
          value: _vm.categoryValue[0],
          subValue: _vm.categoryValue[1],
          list: _vm.categoryList,
          subList: _vm.subCategoryList,
        },
        {
          name: '排序',
          value: _vm.sort,
          list: _vm.sortList,
        } ]},on:{"first-click":_vm.reportFilterClick,"second-click":_vm.reportFilterClick}})]:_vm._e(),_vm._v(" "),(_vm.isCareer && _vm.bannerData)?_c('img',{staticClass:"library-article-banner",attrs:{"src":_vm.bannerData.banner}}):_vm._e(),_vm._v(" "),(_vm.postData)?[_c('div',{staticClass:"library-article-list"},_vm._l((_vm.postData.list),function(item){return _c('article-unit',{key:item.id,staticClass:"library-article-list-item",attrs:{"data":item},nativeOn:{"click":function($event){return _vm.reportClick({ click: 'content', type: item.id })}}})}),1),_vm._v(" "),_c('pagination',{attrs:{"total":_vm.postData.count,"size":_vm.pageSize,"page":_vm.page},on:{"change":_vm.handlePageChange}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }